:host {
  display: flex;
}

.slider-control-root {
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  min-height: 50px;
  min-width: 50px;

  user-select: none;

  pointer-events: none;

  border-radius: 24px;
  border-width: 0;
  outline: 2px solid transparent;
  outline-offset: 2px;

  background-color: var(--slider-control-background-color);
  box-shadow:
    rgba(0, 0, 0, 0) 0 0 0 0,
    rgba(0, 0, 0, 0) 0 0 0 0,
    rgba(58, 64, 70, 0.1) 0 3px 5px 0;

  &:hover {
    background-color: var(--slider-control-background-color--hover);
  }

  &--collapsed {
    width: 50px;

    .slider-control-label {
      display: none;
    }
  }

  &:not(.slider-control-root--collapsed) .slider-control-label {
    margin: 12px 24px;

    font-family: var(--button-font-family);
    font-size: var(--button-font-size);
    text-transform: uppercase;
    color: var(--slider-control-label-color);
    line-clamp: 4;
    -webkit-line-clamp: 4;

    flex: 1;

    display: flex;
    flex-direction: column;
    max-height: calc(1.71em * 4); /* Approx. 4 lines */
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;

    &-left {
      text-align: right;
    }
  }
}
